import type Alpine from 'alpinejs';
import {markLayoutParticipant} from '@client/runtime/layout-participant';

type LayoutDirectiveValue = string | {
    id?: string;
    key?: string;
};

const readExpression = <T>(expression: string | undefined, utilities: Alpine.DirectiveUtilities): T | undefined => {
    if (!expression || typeof utilities.evaluate !== 'function') return undefined;
    return utilities.evaluate(expression) as T;
};

const layoutOptions = (value: LayoutDirectiveValue | undefined): {key?: string} => {
    if (typeof value === 'string') return {key: value};
    if (typeof value === 'object' && value) {
        const key = value.key ?? value.id;
        return key ? {key} : {};
    }
    return {};
};

const registerLayoutDirective = (Alpine: Alpine.Alpine): void => {
    Alpine.directive('ui-layout', (el, {expression}, utilities) => {
        if (!(el instanceof Element)) return;

        const value = readExpression<LayoutDirectiveValue>(expression, utilities);
        const cleanup = markLayoutParticipant(el, layoutOptions(value));

        utilities.cleanup?.(() => {
            cleanup();
        });
    });
};

export {registerLayoutDirective};
